const useIsAdminPanel = () => {
  return window.location.pathname.startsWith("/admin");
}

export default useIsAdminPanel